module.exports = __webpack_public_path__ + "static/media/person-outline.3a5c4d68.svg";